<template>
  <footer class="mt-auto">
    <v-sheet class="py-10 py-md-12 py-lg-16 item primary">
      <v-container>
        <v-row justify="center" justify-md="space-between">
          <v-col cols="12" md="4" lg="3" class="text-center text-md-left">
            <router-link to="/">
              <img
                :src="files + informations.img"
                :alt="informations.name"
                class="d-inline-block"
                height="88px"
                width="100%"
              />
            </router-link>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <div class="d-inline-flex item-title">
              <div class="white--text text-h6 font-weight-bold mb-3">
                Contato

                <v-sheet color="secondary" width="100%" height="2px"></v-sheet>
              </div>
            </div>

            <div class="d-flex flex-column">
              <div
                v-for="(contactItem, contactKey) in contact"
                :key="contactKey"
              >
                <div class="mx-n3" v-if="!Array.isArray(contactItem)">
                  <a
                    v-ripple
                    class="
                      d-inline-flex
                      white--text
                      text-none text-decoration-none
                      px-3
                      py-2
                      item-link
                    "
                    :href="contactItem.link"
                    :target="contactItem.target"
                  >
                    <v-sheet
                      color="transparent"
                      width="20px"
                      class="d-inline-flex justify-center mr-3"
                    >
                      <v-icon class="white--text" :size="contactItem.size">
                        {{ contactItem.icon }}
                      </v-icon>
                    </v-sheet>
                    <span v-html="contactItem.title"></span>
                  </a>
                </div>
                <div v-else>
                  <div
                    class="mx-n3"
                    v-for="(item, itemKey) in contactItem"
                    :key="itemKey"
                  >
                    <a
                      v-ripple
                      class="
                        d-inline-flex
                        white--text
                        text-none text-decoration-none
                        px-3
                        py-2
                        item-link
                      "
                      :href="item.link"
                      :target="item.target"
                    >
                      <v-sheet
                        color="transparent"
                        width="20px"
                        class="d-flex justify-center mr-3"
                      >
                        <v-icon class="white--text" :size="item.size">
                          {{ item.icon }}
                        </v-icon>
                      </v-sheet>
                      <span v-html="item.title"></span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="mx-n3">
                <a
                  v-ripple
                  class="
                    d-inline-flex
                    white--text
                    text-none text-decoration-none
                    px-3
                    py-2
                    item-link
                  "
                  @click="showPrivacy"
                >
                  <v-sheet
                    color="transparent"
                    width="20px"
                    class="d-inline-flex justify-center mr-3"
                  >
                    <v-icon class="white--text" size="18"> fa-shield </v-icon>
                  </v-sheet>
                  <span>Política de Privacidade</span>
                </a>
              </div>
            </div>
          </v-col>

          <v-col cols="12" sm="auto" md="3">
            <div class="d-inline-flex item-title">
              <div class="white--text text-h6 font-weight-bold mb-3">
                Redes Sociais

                <v-sheet color="secondary" width="100%" height="2px"></v-sheet>
              </div>
            </div>

            <div class="d-flex mx-n2">
              <div
                class="mx-2"
                v-for="({ title, link, icon, size }, socialKey) in social"
                :key="socialKey"
              >
                <v-btn
                  class="
                    d-inline-flex
                    white--text
                    text-none text-decoration-none
                    px-3
                    py-2
                    social-btn
                  "
                  min-width="auto"
                  width="36px"
                  height="36px"
                  :href="link"
                  :title="title"
                  target="_blank"
                  color="white"
                  outlined
                  tile
                >
                  <v-icon :size="size">
                    {{ icon }}
                  </v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <v-sheet class="primary">
      <v-container class="py-0">
        <v-divider class="footer-divider white"></v-divider>
        <v-sheet
          min-height="60px"
          class="
            transparent
            white--text
            d-flex
            justify-space-between
            align-center
            flex-column flex-sm-row
            py-4 py-sm-0
          "
        >
          <v-row justify="space-between">
            <v-col cols="12" sm="auto">
              <div class="text-center copyright">
                Copyright @ {{ year }} <b>{{ informations.short_name }}</b
                >. Todos os Direitos Reservados.
              </div>
            </v-col>
            <v-col cols="12" sm="auto">
              <a href="https://mrxweb.com.br/" target="_blank">
                <img
                  class="mx-auto mx-sm-0 d-block"
                  src="/img/mrxweb.svg"
                  height="20px"
                  alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
                  title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
                />
              </a>
            </v-col>
          </v-row>
        </v-sheet>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getContact, getSocial } from "../../config";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return this.$rest("informations-contacts").item;
    },
    medias() {
      return this.$rest("informations-medias").item;
    },
    contact() {
      return getContact(this);
    },
    social() {
      return getSocial(this);
    },
  },
  mounted() {
    this.$rest("informations-contacts").get({
      save: (state, data) => (state.item = data),
    });

    this.$rest("informations-medias").get({
      save: (state, data) => (state.item = data),
    });
  },
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
  },
};
</script>

<style lang="scss" scoped>
.footer-divider {
  opacity: 0.2;
}
.item {
  // background-image: url(/img/bg/footer.jpg);
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  .item-link {
    white-space: pre-wrap !important;
  }
  .social-btn {
    transition: all 0.1s linear;
    &:hover {
      background-color: var(--v-secondary-base) !important;
      border-color: var(--v-primary-base) !important;
      color: #ffffff !important;
    }
  }
}
</style>

<style lang="scss">
.item {
  .item-link {
    span {
      small {
        font-size: 12px !important;
      }
    }
  }
}
</style>
